export const footerProducts = [
  { labelKey: "footerProductUv", category: "uv" },
  { labelKey: "footerProductUvDtf", category: "crystal" },
  { labelKey: "footerProductCylinder", category: "cylinder" },
  { labelKey: "footerProductDtf", category: "dtf" },
  { labelKey: "footerProductDtg", category: "dtg" },
];

export const footerApplications = [
  { labelKey: "footerAppPhoneCase" },
  { labelKey: "footerAppThermos" },
  { labelKey: "footerAppAcrylic" },
  { labelKey: "footerAppGlass" },
  { labelKey: "footerAppMetal" },
  { labelKey: "footerAppLuggage" },
];

export const FOOTER_WHATSAPP_URL = "https://wa.me/8617748697567";

/** 默认联系人（UV / 圆柱 / 水晶标等） */
export const FOOTER_WHATSAPP_CONTACTS = [
  {
    labelKey: "footerWhatsappTang",
    href: "https://wa.me/8617748697567",
  },
  {
    labelKey: "footerWhatsappSun",
    href: "https://wa.me/8615361896795",
  },
];

/** DTF / DTG 分类专用联系人 */
export const FOOTER_WHATSAPP_CONTACTS_DTF_DTG = [
  {
    labelKey: "footerWhatsappTang",
    href: "https://wa.me/8617748697567",
  },
  {
    labelKey: "footerWhatsappSunDtfDtg",
    href: "https://wa.me/8617796314755",
  },
];

export function getFooterWhatsappContacts(categoryId) {
  if (categoryId === "dtf" || categoryId === "dtg") {
    return FOOTER_WHATSAPP_CONTACTS_DTF_DTG;
  }
  return FOOTER_WHATSAPP_CONTACTS;
}
